import React from 'react';
import { trackPropTypes } from "../../../config/defaults";
import SkierIcon from "../../UI/SkierIcon";
import Label from "@/components/UI/Label";
import {
	getLearningAreaColors,
	getLearningAreaLabelColors
} from "@/config/learningAreas";

/**
 * Навчальний майданчик 7E
 *
 * Координати з Figma:
 * - Позиція на карті: translate(1522, 979)
 * - Розмір: 65.13 × 72 px
 */

const Track7EGreen = ({ state, workState, onLabelClick }) => {
	const colors = getLearningAreaColors(state, workState);
	const labelColors = getLearningAreaLabelColors(state, workState);

	return (
		<g id="Track7EGreen" transform="translate(1522, 979)" className="learning-area">
			{/* Зелена лінія (connector) */}
			<g transform="translate(23, 10)">
				<path d="M0.5 9.81146C0.5 4.66889 4.66888 0.500012 9.81145 0.500013L14.6113 0.500013" stroke={colors.areaBorder}
							strokeLinecap="round"/>
			</g>

			{/* Область навчального майданчика */}
			<g transform="translate(0, 21)">
				<path
					d="M21.543 1.18347C24.9141 -0.314697 28.8742 0.875489 30.8604 3.98425L45.3721 26.6981C47.7568 30.4309 46.3828 35.4076 42.4209 37.3885L26.7061 45.246C23.3327 46.9326 19.2308 45.8367 17.1484 42.6923L1.78125 19.4843C-0.766197 15.6365 0.755644 10.422 4.97266 8.54773L21.543 1.18347Z"
					fill={colors.areaFill}
					stroke={colors.areaBorder}
					strokeWidth="1.08"
				/>
			</g>

			{/* Іконка лижника в центрі області */}
			<g transform="translate(15, 36)">
				<rect
					width="16"
					height="16"
					rx="8"
					fill={colors.skierBg}
				/>
				<g transform="translate(3, 3)">
					<SkierIcon color="white" size={12} variant="simple"/>
				</g>
			</g>

			{/* Мітка 7E */}
			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track7EGreen')}
				coords="39.13, 0"
				text="7E"
				textCoordsX="8"
				textCoordsY="16"
				colors={labelColors.colors}
				textColor={labelColors.textColor}
				textSize={10}
				size="small"
			/>
		</g>
	);
};

Track7EGreen.propTypes = trackPropTypes;

export default Track7EGreen;
